<div class="pivot-dialog-header">
    <div class="display-header">
        {{header}}
    </div>
    <button type="button" class="p-dialog-header-icon"
        (click)="onCloseDialogHeader()">
        <span class="pi pi-times"></span>
    </button>
</div>